export var ActionType = /*#__PURE__*/function (ActionType) {
  ActionType[ActionType["Register"] = 0] = "Register";
  ActionType[ActionType["Unregister"] = 1] = "Unregister";
  ActionType[ActionType["UpdateIndex"] = 2] = "UpdateIndex";
  ActionType[ActionType["NextRow"] = 3] = "NextRow";
  ActionType[ActionType["PreviousRow"] = 4] = "PreviousRow";
  ActionType[ActionType["LastRow"] = 5] = "LastRow";
  ActionType[ActionType["FirstRow"] = 6] = "FirstRow";
  ActionType[ActionType["Focus"] = 7] = "Focus";
  ActionType[ActionType["Activate"] = 8] = "Activate";
  ActionType[ActionType["Blur"] = 9] = "Blur";
  return ActionType;
}({});
export var KeyboardEventKey = /*#__PURE__*/function (KeyboardEventKey) {
  KeyboardEventKey["ArrowDown"] = "ArrowDown";
  KeyboardEventKey["ArrowUp"] = "ArrowUp";
  KeyboardEventKey["PageEnd"] = "End";
  KeyboardEventKey["PageStart"] = "Home";
  return KeyboardEventKey;
}({});
export var KeyboardActionToAnalyticSubject = function KeyboardActionToAnalyticSubject(action) {
  switch (action) {
    case ActionType.FirstRow:
      return 'FirstNotification';
    case ActionType.LastRow:
      return 'LastNotification';
    case ActionType.NextRow:
      return 'NextNotification';
    case ActionType.PreviousRow:
      return 'PreviousNotification';
    case ActionType.Activate:
      return 'Activate';
  }
};